import * as React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Content, Props as ContentProps } from './components/Content';

import './index.scss';

interface Props extends ContentProps {
  className?: string;
}

const b = b_.with('idea-landing-submit-section');

export const SubmitSection: React.FC<Props> = ({ idea, className, isExpired, activeOrderId }) => {
  const { t } = useTranslation();
  return (
    <>
      <section className={cn(b(), className)}>
        <h2>{t('Invest in {{name}}', { name: idea.name })}</h2>
        <div>
          <Content idea={idea} isExpired={isExpired} activeOrderId={activeOrderId} />
        </div>
      </section>
    </>
  );
};
